import color from 'color';

import { createUseStyles } from '@glu/theming';

/* istanbul ignore next */
const styles = ({
  breakpoints,
  palette: { error, text },
  spacing: { unit },
  typography: { fontWeightMedium }
}) => ({
  root: {
    alignItems: 'center',
    background: color(error.lightOrange).lighten(0.5).hex(),
    color: text.dark,
    display: 'flex',
    padding: `${unit * 1.25}px ${unit * 2.5}px ${unit * 1.25}px ${unit * 2.5}px`,
    position: 'fixed',
    top: 0,
    left: 60,
    width: `calc(100% - ${unit * 7.5}px)`,
    zIndex: 1100,
    textAlign: 'left',

    [`@media only screen and (max-width: ${breakpoints.values.md}px)`]: {
      padding: unit * 2.5,
      boxShadow: `1px 1px ${unit * 0.625}px ${text.dark}`
    }
  },
  triangle: {
    display: 'flex',

    [`@media only screen and (max-width: ${breakpoints.values.md}px)`]: {
      display: 'flex',
      width: '100%',

      '& svg': {
        height: unit * 2.5,
        margin: '0 auto',
        width: unit * 2.5
      }
    },

    '& svg': {
      fill: error.lightOrange
    }
  },
  info: {
    marginLeft: unit * 2.5,
    textAlign: 'center'
  },
  buttons: {
    display: 'flex',
    marginLeft: unit * 3.75,
    minWidth: 8 * 35,

    '& .btn + .btn': {
      marginLeft: unit * 2.5
    },

    [`@media only screen and (max-width: ${breakpoints.values.md}px)`]: {
      margin: '0 auto'
    }
  },
  strong: {
    fontWeight: fontWeightMedium
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: unit * 3,
    [`@media only screen and (max-width: ${breakpoints.values.md}px)`]: {
      flexDirection: 'column',

      // seperate every element inside
      '& > * + *': {
        marginTop: unit * 2.5
      }
    }
  }
});

export default createUseStyles(styles);
